export default class SearchField {
  constructor() {
    if (!this.setVars()) return;

    this.setEvents();
  }

  setVars() {
    this.searchToggle = document.querySelector('.topMenu__search');
    if (!this.searchToggle) return;

    this.searchPlace = document.querySelector('.overlaySearch');
    if (!this.searchPlace) return;

    this.searchInput = this.searchPlace.querySelector('.overlaySearch__search');
    if (!this.searchInput) return;

    this.searchResults = this.searchPlace.querySelector('.overlaySearch__results');
    this.searchButton  = this.searchPlace.querySelector('.overlaySearch__send');
    this.searchForm    = this.searchPlace.querySelector('.overlaySearch__input');

    this.DEBOUNCE_TIME   = 350;
    this.AMOUNT_OF_WORDS = 20;
    this.PER_PAGE        = (this.searchForm && this.searchForm.dataset.perPage)
      ? this.searchForm.dataset.perPage
      : 5;

    this.searchValue     = null;
    this.results         = null;
    this.data            = null;
    this.isFocused       = false;
    // this.url             = this.searchInput.dataset.url;

    return true;
  }

  setEvents() {
    this.searchToggle.addEventListener('click', this.toggleSearch.bind(this));

    this.searchInput.addEventListener('keyup', this.debounce(() => {
      this.filterData(this.searchInput);
    }, this.DEBOUNCE_TIME));

    const ENTER_CODE = 13;
    this.searchInput.addEventListener('keydown', (event) => {
      if (event.keyCode === ENTER_CODE) this.sendData();
    });

    this.searchButton.addEventListener('click', this.sendData.bind(this));
  }

  toggleSearch() {
    this.searchPlace.classList.toggle('active');
    this.toggleOverflow(this.searchPlace.classList.contains('active'));

    (this.isFocused)
      ? this.searchInput.blur()
      : this.searchInput.focus();

    this.isFocused = !this.isFocused;
  }

  toggleOverflow(activated)
  {
    this.body = document.querySelector('body');

    if (activated) {
      this.body.style.overflow = 'hidden';
    } else {
      this.body.style.overflow = 'initial';
      this.body.style.overflowX = 'hidden';
    }
  }

  debounce(func, delay) {
    let inDebounce;
    return (...args) => {
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => func.apply(this, args), delay);
    };
  }

  filterData(input) {
    this.searchValue = input.value;

    this.getData();
  }

  getData() {
    if (typeof bwpRestUrl === 'undefined') return;

    this.searchResults.innerHTML = `<p class="overlaySearch__singleResult">
      ${window.translations.searchIsRunning}...
    </p>`;

    const searchValueEncoded = encodeURIComponent(this.searchValue);

    fetch(`${bwpRestUrl}bwpspace/v1/search_site?perPage=${this.PER_PAGE}&search=${searchValueEncoded}`)
      .then((res) => res.json())
      .then((data) => {
        this.results = data;
        this.showResults();
      });
  }

  showResults()
  {
    this.data = this.results;
    this.searchResults.innerHTML = '';

    const regEx = new RegExp(this.searchInput.value, 'gi');

    if (!this.data.length) {
      const singleParagraph     = document.createElement('div');
      singleParagraph.innerHTML = `- ${window.translations.noSearchResults} -`;
      singleParagraph.classList.add('overlaySearch__singleResult');
      this.searchResults.appendChild(singleParagraph);

      return;
    }

    // console.log('this.data.length', this.data.length, typeof this.data, this.data);

    this.data.forEach((singleResult) => {
      // const dateOptions   = { day: '2-digit', month: 'short', year: 'numeric' };
      // const date          = new Date(singleResult.date);
      // const dateFormatted = date.toLocaleDateString('de-DE', dateOptions);

      // now we get already formatted date
      const dateFormatted = singleResult.date;

      const singleParagraph = document.createElement('a');
      let paragraphText     = singleResult.title;

      paragraphText = paragraphText
        .split(' ')
        .slice(0, this.AMOUNT_OF_WORDS)
        .join(' ');

      paragraphText = paragraphText
        .replace(regEx, `<strong>${this.searchInput.value}</strong>`);

      singleParagraph.href      = singleResult.link;
      singleParagraph.innerHTML = `${paragraphText} - <span>${dateFormatted}</span>`;
      singleParagraph.classList.add('overlaySearch__singleResult');
      this.searchResults.appendChild(singleParagraph);
    });
  }

  sendData() {
    //deactivate search detail page
    //window.location.href = `?s=${this.searchValue}`;
    event.preventDefault();

  }
}
